import { range } from 'lodash';

export const Progress = ({
  steps,
  stepsCompleted,
}: {
  steps: number;
  stepsCompleted: number;
}) => {
  return (
    <div className="flex gap-3 items-center">
      {range(steps).map((step) => {
        const isCompleted = step < stepsCompleted;
        return (
          <div
            key={step}
            className={`${
              isCompleted ? 'bg-primary' : 'bg-gray-200'
            } rounded-full w-10 h-2`}
          ></div>
        );
      })}
    </div>
  );
};
